import React from "react";
import { useLanguage } from "../i18n/LanguageContext";
import { translations } from "../i18n/translations";
import { images } from "../data/images";

export default function Architecture() {
  const { t } = useLanguage();
  const tx = translations.architecture;

  const blocks = [
    { data: tx.block1, image: images.realLivingRoom, reverse: false },
    { data: tx.block2, image: images.poolArea, reverse: true },
    { data: tx.block3, image: images.realMasterBedroom, reverse: false }
  ];

  return (
    <section id="arquitectura" className="bg-[#F5F0E8] py-24 lg:py-36">
      <div className="max-w-[1500px] mx-auto px-6 lg:px-12">
        <div className="text-center mb-20">
          <div className="flex items-center justify-center gap-4 mb-8">
            <div className="h-[1px] w-10 bg-[#9C8456]" />
            <span
              className="text-[#9C8456] text-[11px] tracking-[0.45em] uppercase"
              style={{ fontFamily: "'Jost', sans-serif" }}
            >
              {t(tx.eyebrow)}
            </span>
            <div className="h-[1px] w-10 bg-[#9C8456]" />
          </div>
          <h2
            className="text-[#2A2A28] text-[34px] sm:text-[48px] lg:text-[58px] leading-[1.08] max-w-4xl mx-auto"
            style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 300 }}
          >
            {t(tx.title1)} <em className="italic">{t(tx.title2)}</em>
          </h2>
        </div>

        {blocks.map((b, i) => (
          <div
            key={i}
            className={`grid lg:grid-cols-12 gap-10 lg:gap-20 items-center ${
              i < blocks.length - 1 ? "mb-28 lg:mb-36" : ""
            }`}
          >
            <div className={`lg:col-span-7 overflow-hidden ${b.reverse ? "lg:order-2" : ""}`}>
              <img
                src={b.image}
                alt={t(b.data.title1)}
                loading="lazy"
                className="w-full h-[460px] lg:h-[640px] object-cover hover:scale-[1.03] transition-transform duration-[1500ms]"
              />
            </div>
            <div
              className={`lg:col-span-5 ${b.reverse ? "lg:order-1 lg:pr-6" : "lg:pl-6"}`}
            >
              <span
                className="text-[#9C8456] text-[11px] tracking-[0.4em] uppercase block mb-5"
                style={{ fontFamily: "'Jost', sans-serif" }}
              >
                {t(b.data.label)}
              </span>
              <h3
                className="text-[#2A2A28] text-[28px] lg:text-[40px] leading-[1.15] mb-6"
                style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 400 }}
              >
                {t(b.data.title1)} <em className="italic">{t(b.data.title2)}</em>
              </h3>
              <p
                className="text-[#3a3a36] text-[16px] lg:text-[17px] leading-[1.85]"
                style={{ fontFamily: "'Jost', sans-serif", fontWeight: 300 }}
              >
                {t(b.data.text)}
              </p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
